<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }" v-m2-span>
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
			width="95%"
			:max-width="1400"
			:min-width="320"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-4 w-100">
						<div class="d-flex flex-row align-center">
                <v-icon color="white" class="info-icon mr-2">mdi-list-box-outline</v-icon>
								<p class="mb-0 font-weight-bold text-primary title">Tablas Resumen</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-2 px-4" style="overflow: hidden;">
            <v-form ref="form">
              <v-row class="mx-0">
								<CostSubcontractPaymentsConfigTable
									:project="projectToPass"
									:ufValue="costs_table.uf_value?.uf_value"
									:currency="costs_table.currency"
									:costsTable="costs_table"
									:saveSelf="true"
									:showTopButtons="false"/>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import CostSubcontractPaymentsConfigTable from '@/components/Views/Projects/CostSummary/CostSubcontractPaymentsConfigTable'

export default {
  name: 'CostBreakdownSubcontractTablesModal',
  components: { CostSubcontractPaymentsConfigTable },
	props: {
		costsTable: {
			type: Object,
			required: true
		},
		project: {
			type: Object,
			required: true
		},
		contract: {
			type: Object,
			default: null
		},
		saveSelfPaymetsConfig: {
			type: Boolean,
			default: false
		}
	},
  computed: {
		costs_table(){
			return {
				...this.costsTable,
				contract: this.contract || null
			}
		},
		projectToPass(){
			const project = {
				...this.project,
				contract: {
					...this.project.contract,
					serial: this.contract?.serial || this.project.contract?.serial || null,
					info: this.contract?.info || this.project.contract?.info || null
				}
			}
			return project
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
	data() {
		return {
			indexModal: + new Date(),
		};
	},
  mounted(){
		console.log('Mounted CostBreakdownSubcontractTablesModal', this.costsTable, this.project, this.contract)
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
    closeModal(){
      this.$store.commit('costbreakdown/setCostBreakdownSubcontractTablesModal', false)
    }
  }
};
</script>

<style scoped>
	.modal-drag-custom-drag {
		width: 100%;
		height: 100%;
	}
	.responsive-container {
		width: 100%;
		overflow-x: auto;
	}
	.responsive-wrapper {
		width: 100%;
		min-width: min-content;
	}
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>